import React, { useState, useEffect } from "react";
import { useGlobal } from "reactn";
import { useHistory, Link } from "react-router-dom";

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, WithStore } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import LazyLoad from "react-lazyload";
import ReactSVG from "react-svg";

import { getRiotAssetsContext } from "@outplayed/riot-assets";

import { useUserPremiumState } from "lib/hooks/userHooks";
import { useJSONFetcher } from "@outplayed/json-fetcher";

import ComboSlider from "components/Champions/Combos/ComboSlider";
import AdBoxWrapper from "components/Ads/AdBoxWrapper";
import AdComponent from "components/Ads/AdComponent";
import StandardSearchInput from "components/StandardSearchInput";

const colorMap = {
  Hard: "#ff9b00",
  Medium: "#08a6ff",
  Easy: "#7ed321",
  Smurf: "#ff4e50",
};

const ComboList = (props) => {
  const { getChampionImg } = getRiotAssetsContext();
  const { data } = props;
  const champImg = getChampionImg(data.key);

  return (
    <div className="champion-combo-container">
      <div className="title-container">
        <div className="cont">
          <img className="champ-img" src={champImg} alt="champ-img" />
        </div>
        <div className="title">
          <div style={{ marginRight: 5 }}>{data.name}</div>
          <div style={{ marginRight: 5, color: "#28283e" }}>/</div>
          <div style={{ color: "#cddcfe", fontWeight: 400 }}>{data.combos.length} Combos</div>
        </div>
      </div>
      <div className="list-container">
        <CarouselProvider naturalSlideWidth={169} naturalSlideHeight={155} visibleSlides={5} totalSlides={data.combos.length}>
          <ComboSlider data={data} />
        </CarouselProvider>
      </div>
      <div className="divider"></div>
    </div>
  );
};

const PremiumHeader = (props) => {
  return (
    <div className="content-side-padding bfg-top-container">
      <div className="bfg-header-text">
        <div className="bfg-sub-title">WIN WITH STYLE</div>
        <div className="bfg-title">
          <div className="align-items-center">
            <img className="boost-logo" src="https://static.bigbrain.gg/assets/ugg/pages/landing/boost-logo-white.svg" />
            <span>COMBO</span>
          </div>
          <div>DATABASE</div>
        </div>
      </div>
      <img className="bfg-img" src="https://static.bigbrain.gg/assets/lol/combos/imgs/sett-combo-preview.png" alt="combo-pic" />
    </div>
  );
};

const FreeHeader = (props) => {
  return (
    <div className="content-side-padding free-top-container">
      <div className="free-header-text">
        <div className="free-title">TIME TO STYLE.</div>
        <div className="free-desc">
          From Easy to Expert, U.GG now offers detailed combos for your favorite champions. First video free. Upgrade to BOOST to
          unlock them all.
        </div>
        <Link to={{ pathname: "/discover-boost", state: { scrollToPlans: true } }} className="btn-light-blue">
          Try BOOST Now
        </Link>
      </div>
      <video loop muted autoPlay className="combo-video">
        <source src="https://static.bigbrain.gg/assets/lol/combos/videos/combo-compilation-1.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

const ComboDatabase = (props) => {
  const { data: combos, loading: isLoading } = useJSONFetcher(
    `https://static.bigbrain.gg/assets/lol/combos/${process.env.COMBOS_FILENAME}.json`,
  );
  const [filteredCombos, setFilteredCombos] = useState([]);
  const [orderedCombos, setOrderedCombos] = useState([]);
  const { isPremium } = useUserPremiumState();
  const [loggingIn] = useGlobal("loggingIn");
  const history = useHistory();

  useEffect(() => {
    let cb = [];
    if (combos && !isLoading) {
      Object.keys(combos)
        .sort()
        .forEach((v, i) => {
          cb.push(combos[v]);
        });
      setOrderedCombos(cb);
      setFilteredCombos(cb);
    }
  }, [combos]);

  const filter = (e) => {
    const filteredCollection = orderedCombos.filter((element) => {
      let simplifiedChampionName = element.id.toLowerCase();
      if (element.id.toLowerCase() == "monkeyking") {
        simplifiedChampionName = "wukong";
      }
      const input = e.target.value.toLowerCase();
      if (simplifiedChampionName.indexOf(input.replace(/ /g, "")) === 0) {
        return true;
      }
      return false;
    });
    setFilteredCombos(filteredCollection);
  };

  if (!loggingIn && !isLoading && combos) {
    return (
      <div className="combo-database-container">
        {isPremium ? <PremiumHeader /> : <FreeHeader />}
        {!isPremium && (
          <div style={{ marginBottom: "-41px" }}>
            <AdBoxWrapper
              styles={{ marginTop: 12, paddingLeft: 21, paddingRight: 21, display: "flex", height: "auto" }}
              minAdWidth={970}
              minAdHeight={90}
            >
              <AdComponent slotId="div-gpt-ad-ugg-9" />
            </AdBoxWrapper>
          </div>
        )}
        <div className="content-side-padding inner-combo-database-container">
          <div className="combo-filters-container">
            <div className="combo-search">
              <input className="combo-search-bar" type="text" onChange={filter} placeholder="Search Champions" />
              <ReactSVG
                wrapperClassName="react-svg search-icon"
                path="https://static.bigbrain.gg/assets/ugg/icons/_ionicons_svg_ios-search.svg"
              />
            </div>
          </div>
          {filteredCombos.length > 0 ? (
            filteredCombos.map((champ, index) => {
              return <ComboList data={champ} key={index} />;
            })
          ) : (
            <div className="not-found-container">
              <div className="title">That champion is in the works or does not exist. Try something else.</div>
              <LazyLoad height={440}>
                <img className="draven" src="https://static.bigbrain.gg/assets/lol/combos/imgs/Draven.png" alt="draven-404" />
              </LazyLoad>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return <div className="spinthatshit-loader"></div>;
  }
};

export default ComboDatabase;
